import { Badge, List } from '@mui/material';
import { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { FileMinus } from 'react-feather';
// import { Badge } from 'reactstrap';

const MAX_TOTAL_SIZE = 10 * 1024 * 1024; // 10 MB

// Estilos para el área de arrastrar y soltar
const dropzoneStyle = {
    border: '2px dashed #cccccc',
    borderRadius: '4px',
    padding: '20px',
    textAlign: 'center',
    cursor: 'pointer',
};

// Lista de errores para mostrar mensajes
const customErrorList = {
    'name-too-large': 'El nombre del archivo supera los 20 caracteres',
    'too-many-files': 'Ha superado el máximo de archivos a adjuntar',
    'file-invalid-type': 'El archivo seleccionado no es un archivo valido',
}

const formatSize = (bytes) => {
    if (bytes >= 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
    if (bytes >= 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${bytes} bytes`;
}

const nameLengthValidator = (file) => {
    // console.log('nameLengthValidator')
    // console.log(file)
    if (file?.name && file.name.length > 30) {
        return {
            code: "name-too-large",
            message: `El nombre del archivo supera los 20 caracteres`
        };
    }
  
    return null
}

const FileManagerInput = (props) => {

    const {
        // datos (listados, individuales)
        acceptedFiles,
        fileRejections,
        NameId,
        typeFiles,
        maxFiles,
        accept,

        // HandleClicks

        // Funciones
        setAcceptedFiles,
        setFileRejections

    } = props

    // Hook: para manejar el mouse over
    const [mouseOver, setMouseOver] = useState(false);
    const [sizeError, setSizeError] = useState(null);

    // Hook: Para manejar el dropzone
    // const {acceptedFiles, fileRejections, getRootProps, getInputProps} = useDropzone();
    const { isDragActive, getRootProps, getInputProps } = useDropzone({
        maxFiles: maxFiles,
        accept: accept,
        validator: nameLengthValidator,
        onDrop: (files) => {
            const totalSize = files.reduce((acc, f) => acc + f.size, 0);
            if (totalSize > MAX_TOTAL_SIZE) {
                setSizeError(
                    `El peso total de los archivos (${formatSize(totalSize)}) supera el límite permitido de 10 MB.`
                );
                setAcceptedFiles([]);
                if (props.onAcceptedFiles) props.onAcceptedFiles([]);
                return;
            }
            setSizeError(null);
            setAcceptedFiles(files); //se vincula para limpiar el listado de documentos adjuntados (aceptados)
            if (props.onAcceptedFiles) {
              props.onAcceptedFiles(files);
            }
        },
        onDropRejected: (rejectedFiles) => {
            setFileRejections(rejectedFiles); //se vincula para limpiar el listado de documentos adjuntados (rechazados)
        },
    })
    
    // Lista para confirmar al usuario los archivos subidos
    const files = acceptedFiles.map(file => (
        <li key={file.path}>
            <Badge  color="success" badgeContent={1}> <FileMinus/> {file.path} - {file.size} bytes </Badge>
            {/* <i className="fa-solid fa-paperclip"></i> {file.path} - {file.size} bytes */}
        </li>

    ));
    
    // Lista para mostrar avisos de errores
    const rejections = fileRejections.map(({ file, errors }) => (

        <li key={file.path} className='text-dark'>
            <Badge className="text-dark" color="light" > <i className="fa-solid fa-circle-exclamation"></i> {file.path} - {file.size} bytes </Badge>
            {/* <i className="fa-solid fa-circle-exclamation"></i> {file.path} - {file.size} bytes */}
            <ul className='text-danger'>
                {errors.map(e => (
                    // <li key={e.code}> <Badge color="danger"> [{e.code}] - {customErrorList[e.code]} </Badge></li>
                    <li key={e.code}> <Badge color="danger"> {customErrorList[e.code]} </Badge></li>
                ))}
            </ul>
        </li>
    ));

    return (
        <>
            <div {...getRootProps()} style={{...dropzoneStyle, background: (mouseOver || isDragActive)? 'rgb(0, 0, 255, 0.1)':'rgb(0, 0, 0, 0)'}} onMouseEnter={() => setMouseOver(true)} onMouseLeave={() => setMouseOver(false)}>
                <input {...getInputProps()} name={NameId} id={NameId}/>
                <p>Arrastra y suelta algunos archivos aquí, o haz clic para seleccionar archivos</p>
                <em>( Archivos permitidos: <b>{maxFiles}</b> | Tipo: <b>{typeFiles}</b> )</em>
            </div>
            <hr/>
            {sizeError && (
                <div style={{ color: '#d32f2f', background: '#fdecea', border: '1px solid #f5c6cb', borderRadius: '4px', padding: '8px 12px', marginBottom: '8px', fontSize: '0.875rem' }}>
                    <i className="fa-solid fa-circle-exclamation" style={{ marginRight: '6px' }}></i>
                    {sizeError}
                </div>
            )}
            <aside>
                <label> Aceptados:</label>
                {/* <ul>{files}</ul> */}
                <List>{files}</List>
                <label> Rechazados:</label>
                {/* <ul>{rejections}</ul> */}
                <List>{rejections}</List>
            </aside>
        </>
    )
}

export {
    FileManagerInput
}